<template>
  <b-modal title="Informações Sobre a Prioridade" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="10">
          <b-form-group label="Cliente:" label-for="cliente" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="cliente" v-model="editing.cliente" />
          </b-form-group>
        </b-col>

        <b-col cols="1">
          <b-form-select v-model="selecionado">
            <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
              >{{ cliente.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="3" label-align-sm="right">
            <b-form-textarea v-model="editing.descricao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Solicitante:" label-for="solic" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="solic" v-model="editing.solicitante" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Forma:" label-for="forma" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="forma" v-model="editing.forma" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Status:" label-for="status" label-cols-sm="3" label-align-sm="right">
            <b-form-select id="status" v-model="editing.status" :options="options" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { usePrioridadeStore } from "@/stores/PrioridadeStore";
import { useClienteStore } from "@/stores/ClienteStore";
import Prioridade from "@/models/Prioridade";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ModalDeEdicaoDePrioridade",

  data() {
    return {
      show: false,
      selecionado: null,
      editing: new Prioridade(0, "Nova Prioridade", "", "", "", new Date(), "não atendida"),
      options: [
        { value: "não atendida", text: "não atendida" },
        { value: "parcialmente atendida", text: "parcialmente atendida" },
        { value: "atendida", text: "atendida" },
      ],
    };
  },

  watch: {
    selecionado: function (cliente) {
      this.editing.cliente = cliente.nome;
    },
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.prioridadeStore.ALTERAR_PRIORIDADE(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Prioridade de equipamento salva no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        this.prioridadeStore
          .CADASTRAR_PRIORIDADE(this.editing)
          .then(() =>
            this.store.NOTIFICAR(new Notificacao("Prioridade de equipamento salva no SGCQ com sucesso!", "Excelente!", "success"))
          );
      }
      this.show = !this.show;
    },

    call(prioridade) {
      this.show = !this.show;
      this.editing = prioridade;
    },
  },

  setup() {
    const store = useSgcqStore();
    const prioridadeStore = usePrioridadeStore();
    const clienteStore = useClienteStore();

    return {
      store,
      prioridadeStore,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
